import * as Sentry from "@sentry/react"

export const initSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,

    environment: import.meta.env.MODE,

    beforeSend(event) {
      // Filter out development errors in production
      if (import.meta.env.PROD && event.exception) {
        const error = event.exception.values?.[0]
        if (error?.value?.includes("Non-Error promise rejection captured")) {
          return null
        }
      }
      return event
    },
  })
}
